import { Component, OnInit } from '@angular/core';
import {Router,ActivatedRoute,Params } from '@angular/router';
import { IMyDpOptions,IMyDateModel } from 'mydatepicker';
import * as moment from 'moment';
import {EmployeeActivateService} from '../services/employee-activate.service'
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';

@Component({
  selector: 'app-employee-activate',
  templateUrl: './employee-activate.component.html',
  styleUrls: ['./employee-activate.component.css']
})
export class EmployeeActivateComponent implements OnInit {
  errorMessage:string = "Server Error";
  public doNotMatch = null;
  public errorStatus;
  public error001 = null;
  public error002 = null;
  public error003 = null;
  public error004 = null;
  public error005 = null;
  public error007 = null;
  public error008 = null;
  public success = null;
  public erroract;
  public invalidEmail:boolean = false;
  public lang ='en';
  initerror;
  successact;
  key;
  error;
  currentPassword:string;
  newPassword:string;
  confirmPasswordVal:string;
  passwordval:string;
  emailIdVal;
  certificatenumberVal;
  public disableSince = {year: moment().year(), month: (moment().get('month')+1), day: moment().date()}
  private dateOfBirth: Object = {};
  public dateOfBirthText;
  public mask = [/[0-9]/, /\d/, '/', /\d/, /\d/,'/', /\d/, /\d/, /\d/, /\d/];
  private myDatePickerOptions:IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showTodayBtn: false,
    markCurrentDay: true,
    showSelectorArrow: true,
    showClearDateBtn : false,
    editableDateField : true,
    disableSince:this.disableSince
  };
  public formatedDob;
  public updateStyle:boolean = false;
  public updateLabel:boolean = false;
  public updateEmailLabel:boolean = false;
  public activateSubscription;
  constructor(public emploeeActService:EmployeeActivateService,
              private route: ActivatedRoute,
              private router:Router,
              private activatedRoute: ActivatedRoute,
              private translate:TranslateService) {
              this.lang = translate.currentLang;
              this.translate.onLangChange.subscribe((event:LangChangeEvent) => {
                this.lang = event.lang;

              });
                }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.key =  params['key'];
      this.activateSubscription = this.emploeeActService.checkActivation(this.key)
        .subscribe(
          res => {
            this.initerror = null;
            this.successact = 'OK';
          },
          error => {
            this.successact = null;
            this.initerror = 'OK';
          });
      });


  }
  ngOnDestroy() {
    this.activateSubscription.unsubscribe();
  }
  checkAccount(key){
    let keyVal = key;
    return this.emploeeActService.checkActivation(keyVal).subscribe(
      res => {
        this.initerror = null;
        this.successact = 'OK';
      },
      error => {
        this.successact = null;
        this.initerror = 'OK';
       });

  }
  activateAccount () {
    if (this.passwordval !== this.confirmPasswordVal) {
      this.error = null;
      this.success = null;
      this.doNotMatch = 'ERROR';
    } else {
      this.error = false;
      this.success = false;
      this.doNotMatch = null;
      this.changeDateFormat();
      this.formatedDob = this.dateOfBirth;
      this.emploeeActService.activateAccount({
        activationKey : this.key,
        certificateNo : this.certificatenumberVal,
        dateOfBirth: this.dateOfBirthText,
        emailId:this.emailIdVal,
        newPassword : this.passwordval,
        confirmPassword : this.confirmPasswordVal,
        language : this.lang
      }).subscribe(
        response => {
          this.resetErrors();
          if(response.status=="100"){

            this.error = null;
            this.success = 'OK';
            //$state.go('home');
            this.router.navigateByUrl('');

          }else if(response.status=="ERRAC000001"){
            this.success = null;
            this.error001 = 'ERROR';

          }else if(response.status=="ERRAC000002"){
            this.success = null;
            this.error002 = 'ERROR';

          }else if(response.status=="ERRAC000003"){
            this.success = null;
            this.error003 = 'ERROR';

          }else if(response.status=="ERRAC000004"){
            this.success = null;
            this.error004 = 'ERROR';

          }else if(response.status=="ERRAC000005"){
            this.success = null;
            this.error005 = 'ERROR';

          }else if(response.status=="ERRAC000007"){
            this.success = null;
            this.error007 = 'ERROR';

          // Disable password history validation
          /*
          }else if(response.status=="ERRAC000008"){
            this.success = null;
            this.error008 = 'ERROR';
          */

          }else{
            this.success = null;
            this.erroract = 'ERROR';


          }
        },
        error => this.errorMessage = <any>error);
    }
  }
  resetErrors() {
    this.error = null;
    this.error001 = null;
    this.error002 = null;
    this.error003 = null;
    this.error004 = null;
    this.error005 = null;
    this.error007 = null;
    this.error008 = null;
  }
  changeDateFormat() {
    Object.keys(this.dateOfBirth).forEach(key => {
      if (key == 'date') {
        this.dateOfBirth = new Date(this.dateOfBirth[key].year, (this.dateOfBirth[key].month) - 1, this.dateOfBirth[key].day);
      }
    });
  }
  onDateChanged(event){
    this.dateOfBirthText = event.formatted;
  }
  updateDatePicker(){
    let split = this.dateOfBirthText.split("/");
    let dd;
    if(split[0] != ''){
      dd = split[0].replace(/[^0-9]/g, '');
    }
    let mm;
    if(split[1] != ''){
      mm = split[1].replace(/[^0-9]/g, '');
    }

    let yyyy;
    if(split[2] != ''){
      yyyy = split[2].replace(/[^0-9]/g, '');
    }
    this.dateOfBirth = {
      date: {
        year: yyyy,
        month: mm.replace(/\b0+/g, ''),
        day: dd.replace(/\b0+/g, '')
      }
    };
  }
  updateLabelStyle(){

    if(this.passwordval != ''){
      this.updateStyle = true;
    } else {
      this.updateStyle = false;
    }
  }
  updateLabelConfirmPasswordlabel(){
    if(this.confirmPasswordVal !=''){
      this.updateLabel = true;
    } else {
      this.updateLabel = false;
    }
  }
  updateEmailIdLabelAndValidate(){
    if(this.emailIdVal !=''){
      this.updateEmailLabel = true;
      let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (reg.test(this.emailIdVal) == false)
      {
        this.invalidEmail = true;
      }
      if (reg.test(this.emailIdVal) == true)
      {
        this.invalidEmail = false;
      }

    } else {
      this.updateEmailLabel = false;
    }
  }
}
